/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */


document.addEventListener("DOMContentLoaded", () => {
  const closeButton   = document.querySelector(".uni_cookie-close");
  const cookieBanner  = document.querySelector(".uni_cookie-container");
  const actionLinks   = document.querySelectorAll(".uni_cookie__button");

  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
  }

  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [key, value] = cookies[i].split("=");
      if (key === name) {
        return value;
      }
    }
    return null;
  }

  function hideBanner() {
    if (!cookieBanner) return;
    cookieBanner.classList.add("hidden");
    setCookie("cookieBannerClosed", "true", 3);
  }

  if (cookieBanner && !getCookie("cookieBannerClosed")) {
    cookieBanner.classList.remove("hidden");
  }

  if (closeButton) {
    closeButton.addEventListener("click", hideBanner);
  }

  if (actionLinks.length) {
    actionLinks.forEach(link => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        hideBanner();
      });
    });
  }
});

